import { defineComponent, createElementBlock, createCommentVNode, openBlock, Fragment, withModifiers, normalizeClass, toDisplayString, capitalize } from "vue";
const _hoisted_1 = ["href"];
const _hoisted_2 = ["href"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HeaderItemTab",
  props: {
    tab: {},
    isEditable: { type: Boolean },
    isMobile: { type: Boolean },
    linkIsActive: { type: Function },
    resolveInternalLinks: { type: Function }
  },
  emits: ["navigate"],
  setup(__props) {
    return (_ctx, _cache) => {
      return _ctx.tab.show || _ctx.isEditable ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        _ctx.isMobile ? (openBlock(), createElementBlock("a", {
          key: 0,
          class: normalizeClass(["header-item-link", {
            "header-item-active": _ctx.linkIsActive(_ctx.tab),
            "header-item-ghost": !_ctx.tab.show
          }]),
          href: _ctx.resolveInternalLinks(_ctx.tab),
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("navigate", _ctx.tab.uid, _ctx.tab.type), ["prevent"]))
        }, toDisplayString(_ctx.tab.title || capitalize(_ctx.tab.type)), 11, _hoisted_1)) : (openBlock(), createElementBlock("a", {
          key: 1,
          class: normalizeClass(["header-item-link", {
            "header-item-active": _ctx.linkIsActive(_ctx.tab),
            "header-item-ghost": !_ctx.tab.show
          }]),
          href: _ctx.resolveInternalLinks(_ctx.tab),
          onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("navigate", _ctx.tab.uid, _ctx.tab.type), ["prevent"]))
        }, toDisplayString(_ctx.tab.title || capitalize(_ctx.tab.type)), 11, _hoisted_2))
      ], 64)) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=HeaderItemTab.vue.js.map
